module.exports = __webpack_public_path__ + "media/evolve/assets/icons/static/design-system-6440373281ac11fa2b7d6da97df5d9fc.svg";